import { type MutationError, trpc } from '@/shared/api';
import { sizeOptionsErrorMessage } from './size-options-error';

interface UseSetSizeOptionsOptions {
  readonly onSuccess?: () => void;
}

/** 사이즈 옵션 저장 — 목록에서 빠진 기존 행은 삭제된다(동기화). */
export const useSetSizeOptions = ({ onSuccess }: UseSetSizeOptionsOptions = {}) => {
  const mutation = trpc.productManagement.products.setSizeOptions.useMutation({ onSuccess });
  const error: MutationError | null =
    mutation.error === null ? null : { message: sizeOptionsErrorMessage(mutation.error) };

  return {
    setSizeOptions: mutation.mutate,
    isPending: mutation.isPending,
    error,
    reset: mutation.reset,
  };
};
